module.exports = __webpack_public_path__ + "img/Virtueal_LOGO_BASE_E_B.bf55ff8b.png";